export const CustomReportConfiguration =
    {
        reportName: '',
        showTotalRow: false,
        showExpandAndCollapseAllRowBtn: false,
        columns: [
            { displayName: 'Area', key: 'area', operation: '', showTotal: false },
            { displayName: 'BI / Actual US$', key: 'biClaim', operation: '', showTotal: false },
            { displayName: 'OP / CAR', key: 'caR_OP', operation: '', showTotal: false },
            { displayName: 'Category 1', key: 'category1', operation: '', showTotal: false },
            { displayName: 'Cause', key: 'cause', operation: '', showTotal: false },
            { displayName: 'Country', key: 'country', operation: '', showTotal: false },
            { displayName: 'Depth at loss (feet)', key: 'depthAtLoss', operation: '', showTotal: false },
            { displayName: 'Drilling Status', key: 'drillingStatus', operation: '', showTotal: false },
            { displayName: 'Event', key: 'event', operation: '', showTotal: false },
            { displayName: 'GOM Area', key: 'gomArea', operation: '', showTotal: false },
            { displayName: 'Location', key: 'location', operation: '', showTotal: false },
            { displayName: 'Land / Offshore', key: 'onOffshore', operation: '', showTotal: false },
            { displayName: 'Loss Type', key: 'lossType', operation: '', showTotal: false },
            { displayName: 'OEE / Actual US$', key: 'oeeClaim', operation: '', showTotal: false },
            { displayName: 'PD /  Actual US$', key: 'pdLiabClaim', operation: '', showTotal: false },
            { displayName: 'ProjTD (feet)', key: 'ptd', operation: '', showTotal: false },
            { displayName: 'Rating Area', key: 'ratingArea', operation: '', showTotal: false },
            { displayName: 'Category 2', key: 'category2', operation: '', showTotal: false },
            { displayName: 'Category 3', key: 'category3', operation: '', showTotal: false },
            { displayName: 'Total / Actual US$', key: 'totalClaim', operation: '', showTotal: false },
            { displayName: 'UGBO', key: 'ugbo', operation: '', showTotal: false },
            { displayName: 'US Location Code', key: 'locationCode', operation: '', showTotal: false },
            { displayName: 'Up/Down/Power', key: 'upDownStream', operation: '', showTotal: false },
            { displayName: 'Well Type', key: 'wellType', operation: '', showTotal: false },
            { displayName: 'Year of Loss', key: 'year', operation: '', showTotal: false },
        ],
        orderBy: { columns: [], orders: [] },
        groups: []
    }


// WEBPACK FOOTER //
// ./src/app/modules/reports/custom-reports/custom-report.configuration.ts